import {
  toDecimal,
  applyDiscount,
  applyTax,
  toMoneyNumber,
} from "../../../../utils/financeEngine";

export const getDefaultCurrency = (pharmacyPOS) => {
  return pharmacyPOS?.allowedCurrencies?.[0] || "INR";
};

export const getSubtotal = (cart = []) => {
  return cart.reduce(
    (sum, item) => sum.add(toDecimal(item.salePrice || 0).mul(toDecimal(item.quantity || 0))),
    toDecimal(0)
  );
};

export const getDiscountAmount = (subtotal, discountType, discountValue) => {
  return applyDiscount(subtotal, discountType, discountValue);
};

export const getTaxAmount = (taxableAmount, taxRate) => {
  return applyTax(taxableAmount, taxRate);
};

export const calculateTotals = ({
  cart = [],
  discountType = "Fixed",
  discountValue = 0,
  transportCost = 0,
  taxRate = 0,
}) => {
  const subtotalD = getSubtotal(cart);
  const discountD = getDiscountAmount(subtotalD, discountType, discountValue);
  const transportD = toDecimal(transportCost || 0);
  const taxableD = subtotalD.minus(discountD).plus(transportD);
  const taxD = getTaxAmount(taxableD, taxRate);
  const netD = taxableD.add(taxD);

  return {
    subtotal: toMoneyNumber(subtotalD),
    discount: toMoneyNumber(discountD),
    transport: toMoneyNumber(transportD),
    tax: toMoneyNumber(taxD),
    netTotal: toMoneyNumber(netD),
  };
};

export const buildInvoicePayload = ({
  cart,
  discountType,
  discountValue,
  taxRate,
  netTotal,
  paidType,
  paymentData,
  customerType,
  selectedPatient,
  prescriptionData,
  pharmacyPOS,
  taxType,
  tax,
  taxPercentage
}) => {
  const items = cart.map((item) => ({
    medicineQunatity: item.quantity,
    medicineName: item.saltName,
    brandName: item.brandName,
    stockId: item.selectedBatchId,
    itemId: item._id,
    batchNumber: item.batchNumber,
    productForm: item.productForm,
    unitPrice: item.salePrice,
    discount: 0,
    isOTC: item.isOTC
  }));

  const body = {
    clinicId: pharmacyPOS?.hospital_id,
    pharmacyId: pharmacyPOS?._id,
    discountType: discountType.toLowerCase(),
    discount: toMoneyNumber(discountValue),
    taxType: taxType || "",
    taxPercentage: toMoneyNumber(taxPercentage),
    tax: toMoneyNumber(tax),
    netTotal: toMoneyNumber(netTotal),
    currencyType: paymentData.currency || getDefaultCurrency(pharmacyPOS),
    paymentType: paymentData.type,
    isConversion: false,
    customerType,
    totalPaid: toMoneyNumber(paymentData.amount),
    isPartialPaid: paidType === "partial",
    isSettled: paymentData.isSettle,
    zigConversionValue: 0,
    items,
  };

  if (paymentData.isSettle) {
    body.isPaid = true;
  } else {
    body.isPaid = paidType === "full";
  }

  if (customerType === "inpatient" && selectedPatient) {
    if (prescriptionData) {
      body.patientId = selectedPatient._id;
      body.patientName = selectedPatient.name;
    } else {
      body.patientId = selectedPatient._id;
      body.patientName = selectedPatient.full_name;
    }
  } else {
    body.patientName = paymentData.patientName || "Walk-in Customer";
  }

  return body;
};
